"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles = __importStar(require("./DressCode.module.css"));
var DressRegulation_1 = require("./parts/DressRegulation");
var StudentAgreement_1 = require("./parts/StudentAgreement");
function DressCode(props) {
    var isPdf = false;
    if (window.isPdf) {
        isPdf = true;
    }
    return (react_1.default.createElement("div", { id: "dress_code", className: styles.containerPosition + " " + styles.breakPage },
        !isPdf && react_1.default.createElement("div", { className: "gray-line " + styles.displayNone }),
        react_1.default.createElement("div", { className: styles.pageSize + " " + styles.paddingSides },
            react_1.default.createElement(DressRegulation_1.DressRegulation, null),
            react_1.default.createElement(StudentAgreement_1.AsherStudentAgreement, null)),
        !isPdf && react_1.default.createElement("div", { className: "gray-line " + styles.displayNone })));
}
exports.DressCode = DressCode;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRHJlc3NDb2RlLmNvbXBvbmVudC5qcyIsInNvdXJjZVJvb3QiOiIuLyIsInNvdXJjZXMiOlsicGRmL2Zvcm1zL2FzaGVyL0RyZXNzQ29kZS9EcmVzc0NvZGUuY29tcG9uZW50LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7QUFBQSxnREFBeUI7QUFFekIsNkRBQWdEO0FBQ2hELDJEQUF1RDtBQUN2RCw2REFBOEQ7QUFFOUQsU0FBZ0IsU0FBUyxDQUFDLEtBQUs7SUFDM0IsSUFBSSxLQUFLLEdBQUcsS0FBSyxDQUFBO0lBRWpCLElBQUksTUFBTSxDQUFDLEtBQUssRUFBRTtRQUNkLEtBQUssR0FBRyxJQUFJLENBQUE7S0FDZjtJQUNELE9BQU8sQ0FDSCx1Q0FBSyxFQUFFLEVBQUMsWUFBWSxFQUFDLFNBQVMsRUFBSyxNQUFNLENBQUMsaUJBQWlCLFNBQUksTUFBTSxDQUFDLFNBQVc7UUFDNUUsQ0FBQyxLQUFLLElBQUksdUNBQUssU0FBUyxFQUFFLGVBQWEsTUFBTSxDQUFDLFdBQWEsR0FBUTtRQUNwRSx1Q0FBSyxTQUFTLEVBQUssTUFBTSxDQUFDLFFBQVEsU0FBSSxNQUFNLENBQUMsWUFBYztZQUN2RCw4QkFBQyxpQ0FBZSxPQUFHO1lBQ25CLDhCQUFDLHdDQUFxQixPQUFHLENBQ3ZCO1FBQ0wsQ0FBQyxLQUFLLElBQUksdUNBQUssU0FBUyxFQUFFLGVBQWEsTUFBTSxDQUFDLFdBQWEsR0FBUSxDQUNsRSxDQUNULENBQUE7QUFDTCxDQUFDO0FBaEJELDhCQWdCQyJ9